export function decodeHexMessage(hexString: string): string {
  try {
    // Remove '0x' prefix if present
    const cleanHex = hexString.startsWith('0x')
      ? hexString.slice(2)
      : hexString;

    // Convert hex to bytes and then to UTF-8 string
    const bytes = new Uint8Array(
      cleanHex.match(/.{1,2}/g)?.map((byte) => Number.parseInt(byte, 16)) || [],
    );
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(bytes);
  } catch (error) {
    // If decoding fails, return the original hex string
    console.warn('Failed to decode hex message:', error);
    return hexString;
  }
}
